export const getAudienceLabel = (audience, t) => {
  if (audience === null || audience === undefined) return null;

  switch (audience) {
    case 0:
      return t("audienceBoth");
    case 1:
      return t("audienceMasters");
    case 2:
      return t("audienceProfessors");
    default:
      return t("audienceUnknown");
  }
};

export const getExperienceLabel = (experience, t) => {
  if (experience === null || experience === undefined) return null;

  switch (experience) {
    case 0:
      return [t("experienceEarlyChildhood")];
    case 1:
      return [t("experienceSpecialEducation")];
    case 2:
      return [t("experienceEarlyChildhood"), t("experienceSpecialEducation")];
    default:
      return [t("experienceUnknown")];
  }
};

export const getLanguageLabel = (languageCode, t) => {
  if (!languageCode) return null;

  const normalized = String(languageCode).toLowerCase();
  if (normalized.startsWith("pt")) return t("languagePortuguese");
  if (normalized.startsWith("en")) return t("languageEnglish");

  return String(languageCode).toUpperCase();
};
